import type { ChatMessage, ReceiptParticipantSummary } from "./chatApi";

export type MessageReceiptVisualStatus = "sent" | "read";

function normalizeSequence(value: number): number {
  if (!Number.isFinite(value)) {
    return 0;
  }
  return Math.max(0, Math.trunc(value));
}

export function resolveOwnMessageReceiptStatus(input: {
  message: Pick<ChatMessage, "sequence" | "sender_user_id" | "deleted_at">;
  actorUserID: string | null;
  participantReceipts: ReceiptParticipantSummary[];
}): MessageReceiptVisualStatus | null {
  const actorUserID = input.actorUserID?.trim() ?? "";
  const messageSequence = normalizeSequence(input.message.sequence);
  if (actorUserID === "" || input.message.sender_user_id !== actorUserID || input.message.deleted_at !== undefined) {
    return null;
  }
  if (messageSequence <= 0) {
    return null;
  }

  const peerReceipts = input.participantReceipts.filter((receipt) => receipt.user_id.trim() !== actorUserID);
  if (peerReceipts.length === 0) {
    return "sent";
  }

  const allPeersRead = peerReceipts.every((receipt) => normalizeSequence(receipt.read_seq) >= messageSequence);
  if (allPeersRead) {
    return "read";
  }

  return "sent";
}
